import React, { useEffect, useRef, useState } from 'react';
import {ReleaseOrders} from './releaseOrders/ui/screen/releaseOrders';
export default function ReleasedOrdersConfiguration() {

    return (
        <div>
           <ReleaseOrders></ReleaseOrders>
        </div>
    );
}